export default {
  default: 1,
  modal: 600000,
  zenDesk: 900000,
  portal: 1000000,
  tooltip: 1000900,
}
